module.exports = __webpack_public_path__ + "img/pdf.3d84b0c2.jpg";